module.exports = __webpack_public_path__ + "img/Way8.2276d017.svg";